import React from 'react';
import PropTypes from 'prop-types';
import SrFlex from 'client/components/SrFlex';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrQualifiedListItem = ({ isQualified, title, titleSize, detail, marginTop }) => {
  const _getStatusIcon = () => {
    if (isQualified === null) {
      return '/images/checkmark-grey.svg';
    }
    if (isQualified) {
      return '/images/checkmark-circle-green-no-shadow.svg';
    }
    return '/images/x-circle-icon-red.svg';
  };

  const statusIcon = _getStatusIcon();

  return (
    <SrFlex marginTop={marginTop}>
      <SrFlex width="25px" justify="center" paddingTop="4px">
        <SrBox width="20px" height="20px" backgroundImage={`url(${statusIcon})`} />
      </SrFlex>
      <SrBox marginLeft="5px" minWidth="200px">
        <SrText font="greycliff" fontSize={titleSize || '16px'} weight="700">
          {title}
        </SrText>
        &nbsp;
        {detail}
      </SrBox>
    </SrFlex>
  );
};

SrQualifiedListItem.propTypes = {
  isQualified: PropTypes.bool,
  title: PropTypes.string.isRequired,
  titleSize: PropTypes.string,
  detail: PropTypes.node.isRequired,
  marginTop: PropTypes.string,
};

export default SrQualifiedListItem;
